import { ChildWithParentsIds, ChildWithParents } from 'types';

export const parseChildWithParentsIntoChildWithParentsIds: (
    childWithParents: ChildWithParents,
) => ChildWithParentsIds = (childWithParents) => ({
    childId: childWithParents.id,
    parentIds: childWithParents.parents.map((parent) => parent.id),
});
